import "./App.css";
import ProcessFiles from "./app/pages/CalcFare";

function App() {
  return (
    <div>
      <ProcessFiles />
    </div>
  );
}

export default App;
